import { PropsWithChildren } from 'react';

import { cn } from '@/shared/utils/cn';

type SectionHeaderProps = {
  children?: React.ReactNode;
};

export const SectionHeader = ({ children }: SectionHeaderProps) => {
  return (
    <div className="flex flex-row items-center justify-between">{children}</div>
  );
};

export const SectionTitle = ({
  children,
  className,
  onClick,
}: PropsWithChildren & { className?: string; onClick?: () => void }) => (
  <span onClick={onClick} className={cn('text-base text-white', className)}>
    {children}
  </span>
);

export const SectionActions = ({
  children,
}: {
  children: React.ReactNode[];
}) => <div className="flex flex-row gap-3">{children}</div>;
